<template>
  <div class="page-wrapper">
    <div class="page-inner">
      <layout-navbar />

      <div class="page-content-wrapper">
        <div v-if="passwordExpiresSoon" class="alert-row" role="alert">
          Twoje hasło wygaśnie {{ date(passwordExpireDate) }}.
          <router-link class="link color-white" :to="{ name: 'updatePassword' }">Zmień swoje hasło teraz.</router-link>
        </div>

        <layout-header />

        <layout-body />

        <layout-footer />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import LayoutBody from '@/components/appLayout/Body.vue';
import LayoutFooter from '@/components/appLayout/Footer.vue';
import LayoutHeader from '@/components/appLayout/Header.vue';
import LayoutNavbar from '@/components/appLayout/Navbar.vue';
import { date } from '@/filters/date';
import { getTokenData } from '@/utils/tokenData';

// @vuese
// Layout aplikacji
// @group Layouts
export default {
  components: {
    LayoutHeader,
    LayoutNavbar,
    LayoutBody,
    LayoutFooter
  },

  computed: {
    passwordExpireDate() {
      return getTokenData()?.user?.passwordValidUntil;
    },

    passwordExpiresSoon() {
      return (
        this.passwordExpireDate &&
        moment()
          .add(3, 'days')
          .isAfter(this.passwordExpireDate)
      );
    }
  },

  methods: {
    // @vuese
    // Formatowanie daty
    date
  }
};
</script>

<style>
.alert-row {
  background: #ad5c00;
  padding: 10px;
  color: white;
  font-weight: bold;
}
</style>
